// 페이지 내 좌측 리스트 컬럼의 좌우 폭 드래그 리사이즈 공용 헬퍼.
// 글로벌 사이드바(left=0이라 raw clientX)와 달리, 페이지 컬럼은 left≠0 → 폭 = (clientX - 컬럼.left) ÷ 배율 로 보정.
//   웹 배율(<html> zoom)이 걸리면 clientX·rect 는 화면 px, 폭은 CSS px 다 → 컬럼으로 배율을 재서 나눈다(jsdom·1.0 은 1).
// 핸들 <div>는 컬럼 컨테이너(position:relative)의 우측 가장자리 자식이어야 함(parentElement=컬럼).
import { scaleOf } from '../lib/floatingBounds';

export function startColResize(e, setW, lsKey, min = 180, max = 460) {
  e.preventDefault();
  const col = e.currentTarget.parentElement;
  const r = col ? col.getBoundingClientRect() : null;
  const left = r ? r.left : 0;
  const s = r ? scaleOf(r.width, col.offsetWidth) : 1;
  // 드래그 동안 전체화면 투명 오버레이 — iframe/요소가 mousemove를 삼키는 것 방지
  const ov = document.createElement('div');
  ov.style.cssText = 'position:fixed;inset:0;z-index:99999;cursor:col-resize';
  document.body.appendChild(ov);
  document.body.style.userSelect = 'none';
  const onMove = (ev) => setW(Math.min(max, Math.max(min, Math.round((ev.clientX - left) / s))));
  const onUp = () => {
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onUp);
    document.body.style.userSelect = '';
    if (ov.parentNode) ov.parentNode.removeChild(ov);
    setW((w) => { try { localStorage.setItem(lsKey, String(w)); } catch (e2) {} return w; });
  };
  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup', onUp);
}
